import {StaticUnifiedDiffPreview} from '@github-ui/diff-lines/static-unified-diff-preview'
import type {SafeHTMLString} from '@github-ui/safe-html'
import {VerifiedHTMLDiv} from '@github-ui/safe-html/VerifiedHTML'
import {clsx} from 'clsx'
import {type FC, useMemo} from 'react'
import {getEntityDiffContent, getEntityMessageHtml, getEntitySuggestedFixDescriptionHtml} from './entity-helpers'
import styles from './Finding.module.css'
import type {FindingEntity} from './types'

interface AnnotationFindingDetailsProps {
  finding: FindingEntity & {entityType: 'annotation'}
}

export const AnnotationFindingDetails: FC<AnnotationFindingDetailsProps> = ({finding}) => {
  const diffEntries = useMemo(() => getEntityDiffContent(finding), [finding])
  const messageHtml = getEntityMessageHtml(finding)
  const suggestedFixDescriptionHtml = getEntitySuggestedFixDescriptionHtml(finding)

  return (
    <>
      <div className={styles.section}>
        {messageHtml ? (
          // eslint-disable-next-line @github-ui/github-monorepo/no-cast-as-safe-html-string -- sanitized on the backend
          <VerifiedHTMLDiv className="markdown-body comment-body" html={messageHtml as SafeHTMLString} />
        ) : (
          <p>{finding.entity.message}</p>
        )}
      </div>
      {(suggestedFixDescriptionHtml || diffEntries.length > 0) && (
        <div className={styles.section}>
          <h4 className={styles.sectionTitle}>Suggestions</h4>
          {suggestedFixDescriptionHtml && (
            <VerifiedHTMLDiv
              // eslint-disable-next-line @github-ui/github-monorepo/no-cast-as-safe-html-string -- sanitized on the backend
              html={suggestedFixDescriptionHtml as SafeHTMLString}
              className="markdown-body comment-body"
            />
          )}
          {diffEntries.map(entry => (
            <div key={entry.path} className={styles.diffPreview}>
              <div className={clsx('d-flex flex-column overflow-hidden', styles.diffEntryHeader)}>
                <div className="d-flex flex-items-center tmp-px-3 py-2 text-small gap-2 text-mono">{entry.path}</div>
                <StaticUnifiedDiffPreview
                  tabSize={4}
                  className={clsx('m-0 border-bottom borderColor-default overflow-hidden', styles.automatedReviewDiff)}
                  diffTableClassName="borderColor-default"
                  diffLines={entry.diffLines}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  )
}
